import React, { FunctionComponent } from "react";
import "./Scrollbar.css";

export interface ScrollbarProps {
  /**
   * Optional CSS class name
   */
  className?: string;

  /**
   * Size variant of the scrollbar
   */
  size?: "sm" | "md" | "lg";
}

export const Scrollbar: FunctionComponent<ScrollbarProps> = ({
  className = "",
  size = "md",
}) => {
  const containerClasses = [
    "qida-scrollbar",
    `qida-scrollbar--${size}`,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={containerClasses}>
      <div className="qida-scrollbar__heading">
        <div className="qida-scrollbar__components">Components</div>
        <div className="qida-scrollbar__title">Scroll bar</div>
        <div className="qida-scrollbar__divider" />
      </div>
      <div className="qida-scrollbar__subtitle">Scroll bar</div>
      <div className="qida-scrollbar__sizes">
        <div className="qida-scrollbar__size qida-scrollbar__size--sm">
          <div className="qida-scrollbar__track">
            <div className="qida-scrollbar__thumb" />
          </div>
        </div>
        <div className="qida-scrollbar__size qida-scrollbar__size--md">
          <div className="qida-scrollbar__track">
            <div className="qida-scrollbar__thumb" />
          </div>
        </div>
        <div className="qida-scrollbar__size qida-scrollbar__size--lg">
          <div className="qida-scrollbar__track">
            <div className="qida-scrollbar__thumb" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Scrollbar;
